import React from 'react'
import {useNavigate, useLocation } from 'react-router-dom'
import './reservaCreada.css';
import './Layout.css';
import Footer from './footer';
import { Helmet } from 'react-helmet-async';

export default function ReservaCreada() {
    const navigate = useNavigate()
    const location = useLocation()
    const reserva = location.state?.reserva
    const convertirFechaTexto = (fechaString) => {
      const fecha = new Date(fechaString + 'T00:00:00'); // Convertir a Date (Evita problemas de zona horaria)
      return fecha.toLocaleDateString('es-ES', { 
          weekday: 'long', 
          day: 'numeric', 
          month: 'long', 
          year: 'numeric' 
      });
      
      
  };
  console.log(reserva)
  const pagoRestante = reserva.precio - reserva.deposito;
  
  const fecha = convertirFechaTexto(reserva.fecha)
    if (!reserva) {
        return <h2>No hay datos de reserva</h2>;
      }

  return (
    <>
    <Helmet>
      <title>Reserva Creada</title>
    </Helmet>
      <div className='contenedor-pagina'>
      <div className="modal-complete">
        <div className="modal-content">
          <h2 className="modal-title">Reserva creada con éxito</h2>
          <p className='nota'>A continuación puedes ver los detalles de tu reserva:</p>
          <h3>Reserva No. {reserva.IdReserva}</h3>
          {/* Datos del Cliente */}
          <div className="section">
            <h3>Datos del cliente</h3>
            <p><strong>Nombre:</strong> {reserva.cliente.nombre}</p>
            <p><strong>Teléfono:</strong> {reserva.cliente.telefono}</p>
            <p><strong>Email:</strong> {reserva.cliente.email}</p>
          </div>

          {/* Detalles de la Reserva */}
          <div className="section">
            <h3>Detalles de la reserva</h3>
            <p><strong>Numero de reserva:</strong> {reserva.IdReserva}</p>
            <p><strong>Fecha:</strong> {fecha}</p>
            <p><strong>Hora:</strong> {reserva.hora}</p>
            <p><strong>Cancha:</strong> Fut {reserva.tipo_cancha}</p>
            <p><strong>Costo de la cancha:</strong> Q.{reserva.precio}.00</p>
            <p><strong>Estado de la reserva:</strong>&nbsp;<span>Pendiente</span></p>
          </div>

          {/* Información del Establecimiento */}
          <div className="section">
            <h3>Detalles del Establecimiento</h3>
            <p><strong>Nombre:</strong> {reserva.Establecimiento.nombre}</p>
            <p><strong>Dirección:</strong> {reserva.Establecimiento.direccion}</p>
            <p><strong>Teléfono:</strong> {reserva.Establecimiento.telefono}</p>
          </div>

          {/* Información de Pago 
          <div className="section">
            <h3>Detalles del Pago</h3>
            <p><strong>Monto Pagado:</strong> ${reserva.pago.monto}</p>
            <p><strong>Método de Pago:</strong> {reserva.pago.metodo}</p>
            <p><strong>Referencia:</strong> {reserva.pago.referencia}</p>
          </div>*/}

          <div className="section">
            <h3>Detalles del Pago</h3>
            <p><strong>Monto Pagado:</strong> Q.{reserva.deposito + 1}.00</p>
            <p><strong>Monto restante de pagar:</strong> Q.{pagoRestante}</p>
            <p><strong>Referencia:</strong> 12345</p>
          </div>


          {/* Botón de Regresar */}
          <button className="btn-regresar" onClick={() => navigate("/")}>
            Regresar
          </button>
        </div>
      </div>
      <Footer/>
      </div>
    </>
  )
}